export default __webpack_public_path__ + "static/media/try-atomic-diet-select.c2a51a51.png";